'use strict';
import projectsAssetProjectsListTemplate from './controllers/asset-projects-list.html';
import projectsRootTemplate from './controllers/project.html';
import projectsManageAssetsTemplate from './controllers/projects-manage-assets.html';
import {projectStates} from './router-config';


routerConfig.$inject = [
  '$stateProvider',
];

export function routerConfig(
  $stateProvider,
) {
  $stateProvider
    .state(projectStates.projectsRoot, {
      url: '/projects',
      abstract: true,
      views: {
        'appContent': {
          template: projectsRootTemplate,
          controller: 'ProjectController',
        },
      },
    })

    .state(projectStates.projectsAssetProjectsList, {
      title: 'projects.views.assets.title',
      url: '/assets-list',
      views: {
        'tab-projects-tasks': {
          template: projectsAssetProjectsListTemplate,
          controller: 'ProjectsAssetProjectsListController',
        },
      },
    })

    .state(projectStates.projectsManageAssets, {
      title: 'projects.assets.manage.header.label',
      url: '/manage-assets',
      views: {
        'tab-projects-tasks': {
          template: projectsManageAssetsTemplate,
          controller: 'ProjectsManageAssetsController',
        },
      },
    });
}



// WEBPACK FOOTER //
// ./src/js/projects/router.js